import { useEffect, useState } from 'react';
import { auth } from '../../firebase/firebase.js';
import { logError } from '../../firebase/errorReporting';

/**
 * Whether the signed-in user carries the `admin` custom claim.
 *
 * AdminGaurd does this for a whole route; this is the same check for a single
 * control inside a page everybody can see. It fails closed — an unreadable token
 * is not an admin — and returns false until the token resolves, so nothing
 * admin-only flashes on screen for a normal user first.
 *
 * This hides a control. It is not access control: the data it reveals sits at a
 * public path, so nothing goes behind this that could not be read by a stranger
 * who knew the URL.
 */
export function useIsAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const uid = auth.currentUser?.uid;

  useEffect(() => {
    if (!auth.currentUser) { setIsAdmin(false); return undefined; }
    let cancelled = false;
    auth.currentUser.getIdTokenResult()
      .then((t) => { if (!cancelled) setIsAdmin(!!t.claims.admin); })
      .catch((err) => {
        logError(err, { component: 'useIsAdmin' });
        if (!cancelled) setIsAdmin(false);
      });
    return () => { cancelled = true; };
  }, [uid]);

  return isAdmin;
}
